import { h } from 'preact';
import ProfileView from './profile';
import ProfilePhoneView from './profile-phone';
import provideFinanceModel from '../provide-finance-model';

//Export the view components after wrapping them with the model providers for the
//finance data

export default provideFinanceModel(ProfileView);
export let ProfilePhone = provideFinanceModel(ProfilePhoneView);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/company-profile/index.js